import required from '../../../form/field-validation/required';

export const basic = required();
export const email = required('email');
export const fullName = required('fullName');
export const company = required('company');
export const firstName = required('firstName');
export const lastName = required('lastName');
export const address1 = required('address1');
export const address2 = required('address2');
export const houseNumber = required('houseNumber');
export const townCity = required('town');
export const county = required('county');
export const state = required('state');
export const postCode = required('postcode');
export const dateOfBirth = required('dateOfBirth');
export const creditCardNumber = required('creditCardNumber');
export const nameOnCard = required('nameOnCard');
export const newCardCv2 = required('newCardCv2');
export const storedCardCV2 = required('storedCardCV2');
export const acknowledgedMessage = required('acknowledgedMessage');
export const euVatNumber = required('euVatNumber');
export const iban = required('iban');
export const salutation = required('salutation');
export const socialSecurity = required('socialSecurity');
export const billingContactNumber = required('billingContactNumber');
export const companyIdentificationNumber = required('companyIdentificationNumber');
export const klarnaFirstName = required('klarnaFirstName');
export const klarnaSurname = required('klarnaSurname');
export const klarnaEmail = required('klarnaEmail');
export const klarnaPhone = required('klarnaPhone');
export const klarnaAcknowledgedMessage = required('klarnaAcknowledgedMessage');
export const klarnaDob = required('klarnaDob');
export const klarnaGender = required('klarnaGender');
